const data = {
  id: 1,
  title: 'Choose the word whose main stressed syllable is placed differently from the other three in pronunciation.',
  subTitle: 'Chọn từ có trọng âm ở vị trí khác các từ còn lại.',
  question: null,
  answers: [
    { id: 1, answer: 'married', isCorrect: false },
    { id: 2, answer: 'energy', isCorrect: false },
    { id: 3, answer: 'develop', isCorrect: true },
    { id: 4, answer: 'vintage', isCorrect: false },
  ],
};

export default data;
